import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-many-tools-grammar-checker',
  templateUrl: './many-tools-grammar-checker.component.html',
  styleUrls: ['./many-tools-grammar-checker.component.scss']
})
export class ManyToolsGrammarCheckerComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
